import { create } from 'zustand'

const STORAGE_KEY = 'offlineModeEnabled'

type OfflineModeState = {
  isOfflineModeEnabled: boolean
  enabledAt: number | null
  enableOfflineMode: () => void
  disableOfflineMode: () => void
}

const readPersistedState = (): { enabled: boolean; enabledAt: number | null } => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { enabled: false, enabledAt: null }
    const parsed = JSON.parse(raw) as { enabled: boolean; enabledAt: number | null }
    return { enabled: parsed.enabled ?? false, enabledAt: parsed.enabledAt ?? null }
  } catch {
    return { enabled: false, enabledAt: null }
  }
}

const persistState = (enabled: boolean, enabledAt: number | null): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ enabled, enabledAt }))
  } catch {
    // localStorage unavailable — non-critical
  }
}

const initial = readPersistedState()

export const useOfflineModeStore = create<OfflineModeState>(set => ({
  isOfflineModeEnabled: initial.enabled,
  enabledAt: initial.enabledAt,
  enableOfflineMode: () => {
    const now = Date.now()
    persistState(true, now)
    set({ isOfflineModeEnabled: true, enabledAt: now })
  },
  disableOfflineMode: () => {
    persistState(false, null)
    set({ isOfflineModeEnabled: false, enabledAt: null })
  },
}))

/** Plain getter for non-React contexts (api-client, loaders, etc.) */
export const getIsOfflineModeEnabled = (): boolean =>
  useOfflineModeStore.getState().isOfflineModeEnabled
